export interface Zone {
  id: string
  number: number | "R"
  emoji: string
  name: string
  description: string
  plantMetaphor: string
  highwayMetaphor: string
  shortTermAction: string
  longTermAction: string
  color: string
}

export const zones: Zone[] = [
  {
    id: "1",
    number: 1,
    emoji: "💀",
    name: "Hniloba / Úplná stagnace",
    description: "Úplná nehybnost, ztráta smyslu, prázdnota, odpojení.",
    plantMetaphor: "Vadnoucí rostlina bez světla a vody.",
    highwayMetaphor: "Auto stojí v garáži, vybitá baterie.",
    shortTermAction: "Aktivuj tělo: jdi ven, procházka, sprcha, pohyb, světlo.",
    longTermAction:
      "Vyhledej nový impulz – kontakt s lidmi, změna prostředí, terapeut, malý projekt, který tě znovu propojí se životem.",
    color: "oklch(0.35 0.05 280)",
  },
  {
    id: "2",
    number: 2,
    emoji: "💤",
    name: "Útlum / Pomalý restart",
    description: "Nízká energie, přežívání, rutina bez jiskry.",
    plantMetaphor: "Kytka ve stínu – žije, ale neroste.",
    highwayMetaphor: "Motor běží na volnoběh.",
    shortTermAction: "Drobné podněty – hudba, pohyb, světlo, jednoduché úkoly.",
    longTermAction:
      "Uprav rytmus dne – více světla, pohybu, spánku, sociální kontakt, struktura. Vrať se k drobným rituálům.",
    color: "oklch(0.50 0.08 250)",
  },
  {
    id: "3",
    number: 3,
    emoji: "🪷",
    name: "Pasivní klid / Komfortní stagnace",
    description: "Klid, ale i vnitřní otupělost, nehybnost.",
    plantMetaphor: "Kytka čeká na jaro – živá, ale bez růstu.",
    highwayMetaphor: "50 km/h – jistota, ale bez cíle.",
    shortTermAction: "Zapoj jemnou stimulaci – rozhovor, kreativita, příroda.",
    longTermAction: "Pokud trvá, vědomě naruš rutinu. Změň prostředí, zapoj tělo. Malé dávky výzvy, ne tlak.",
    color: "oklch(0.65 0.10 200)",
  },
  {
    id: "4",
    number: 4,
    emoji: "🌤️",
    name: "Aktivace / Probouzení",
    description: "Energie se zvedá, objevuje se zvědavost.",
    plantMetaphor: "Listy se obrací ke světlu.",
    highwayMetaphor: "90 km/h – rozjíždíš se.",
    shortTermAction: "Udělej první krok, ale nespěchej. Vnímej tělo, rytmus.",
    longTermAction: "Vytvářej zdravý denní rytmus: činnost ↔ odpočinek. Stanov hranice výkonu dřív, než se přetížíš.",
    color: "oklch(0.75 0.12 180)",
  },
  {
    id: "5",
    number: 5,
    emoji: "🌼",
    name: "Růstová rovnováha / Flow",
    description: "Soustředění, přítomnost, vyvážený výkon.",
    plantMetaphor: "Kytka má ideální světlo i půdu.",
    highwayMetaphor: "120–130 km/h – ideální tempo.",
    shortTermAction: "Mikro pauzy, dýchej, jedna věc naplno.",
    longTermAction:
      "Dlouhodobě pečuj o rovnováhu – střídání nádechu/výdechu, cyklus práce a klidu. Nepřeháněj produktivitu.",
    color: "oklch(0.80 0.12 150)",
  },
  {
    id: "6",
    number: 6,
    emoji: "⚡",
    name: "Výkon s vědomím hranic",
    description: "Vysoké tempo, energie proudí, lehké napětí.",
    plantMetaphor: "Rychlý růst, zdravé zakořenění.",
    highwayMetaphor: "140 km/h – svižné, ale kontrolované.",
    shortTermAction: "Pauzy, protažení, dech, kontakt. Nepřidávaj tempo.",
    longTermAction: 'Zaváděj dny „bez výkonu". Vytvářej vědomé výdechy. Nepěstuj si identitu „vždy výkonného".',
    color: "oklch(0.78 0.12 120)",
  },
  {
    id: "7",
    number: 7,
    emoji: "🌪️",
    name: "Napětí / Předstres",
    description: "Tlak, únava, systém jede, ale přehřívá se.",
    plantMetaphor: "Kytka se natahuje jen za světlem – kořeny slábnou.",
    highwayMetaphor: "150–160 km/h – riziko stoupá.",
    shortTermAction: "Uzemni se, dýchej, pij, protáhni se, plánuj výjezd.",
    longTermAction: "Dlouhodobě zreviduj závazky. Nauč se delegovat, komunikovat hranice, říkat ne. Změň rytmus práce.",
    color: "oklch(0.75 0.14 80)",
  },
  {
    id: "8",
    number: 8,
    emoji: "🔥",
    name: "Přetížení / Setrvačnost",
    description: "Jedeš ze zvyku, ztrácíš nadhled, únava, podráždění.",
    plantMetaphor: "Listy se pálí, půda suchá.",
    highwayMetaphor: "170 km/h – výkon klesá, riziko roste.",
    shortTermAction: "Zastav, ztiš se, sniž nároky, regeneruj.",
    longTermAction: "Proveď strukturální změnu – deleguj, uber, dovol si volno. Obnov kontakt s tělem a lidmi.",
    color: "oklch(0.70 0.16 50)",
  },
  {
    id: "9",
    number: 9,
    emoji: "💥",
    name: "Kolaps v pohybu / Pád",
    description: "Přetlak, rozpad kontroly, emoční i tělesné vyčerpání.",
    plantMetaphor: "Rostlina se láme, listy vadnou.",
    highwayMetaphor: "180–190 km/h – systém se rozpadá.",
    shortTermAction: "Zastav. Vypni vše, dýchej, kontaktuj podporu.",
    longTermAction: "Přepni na léčebný režim. Spánek, výživa, dotek, terapeut. Analyzuj příčiny až po zotavení.",
    color: "oklch(0.65 0.18 30)",
  },
  {
    id: "10",
    number: 10,
    emoji: "🩸",
    name: "Havárie / Vyhoření",
    description: "Totální kolaps energie, ztráta smyslu, emoční prázdno.",
    plantMetaphor: "Kytka uschla, potřebuje nový cyklus růstu.",
    highwayMetaphor: "Auto havarovalo, stojíš na krajnici.",
    shortTermAction: "Stop. Bezpečí, klid, žádné úkoly. Pomoc terapeuta.",
    longTermAction: "Dlouhodobá obnova základů: spánek, kontakt, změna životního rytmu, léčba, nové zakořenění.",
    color: "oklch(0.60 0.20 20)",
  },
  {
    id: "R",
    number: "R",
    emoji: "🌗",
    name: "Regenerační zóna / Tiché přistání",
    description: 'Zpomalování po výkonu. Únava, prázdno, „necitlivost".',
    plantMetaphor: "Rostlina po rychlém růstu – zakořeňuje, stabilizuje se.",
    highwayMetaphor: "Sjíždíš z dálnice – motor hřeje, tělo dohání klid.",
    shortTermAction: "Dovol únavě být. Spánek, voda, teplo, dech. Žádné hodnocení.",
    longTermAction:
      "Naplánuj regeneraci jako součást výkonu. Vyhýbej se rozhodnutím, dej tělu prostor na integraci. Počkej, až se energie znovu objeví sama.",
    color: "oklch(0.70 0.10 220)",
  },
]

export function getZoneById(id: string): Zone | undefined {
  return zones.find((z) => z.id === id)
}

export function getZoneColor(zoneId: string): string {
  const zone = getZoneById(zoneId)
  return zone?.color || "oklch(0.70 0.10 200)"
}

/**
 * Get numeric value for zone calculations
 * Maps zone "R" (Recovery) to 0 for semantic correctness
 * Recovery represents intentional downtime/low energy after performance
 */
export function getZoneNumericValue(zoneId: string): number {
  if (zoneId === "R") return 0
  const zone = getZoneById(zoneId)
  return zone && typeof zone.number === "number" ? zone.number : 0
}
